const getApiResponseStatus = (error: {
  graphQLErrors?: { extensions?: { response?: { status: number } } }[];
}): number | undefined => error.graphQLErrors?.[0]?.extensions?.response?.status;

export { getApiResponseStatus };
